import { Box } from '@mui/material';
import React, { useEffect } from 'react';

import SelectUserReceiveCertificate from '../SelectUserReceiveCertificate';

const OwnerInfoArtistCreateCer = ({ ownerHookForm }) => {
  const { formState, setValue } = ownerHookForm;

  const handleUserChange = (newValue, shouldValidate = true) => {
    setValue('owner', newValue, { shouldValidate });
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formState.defaultValues]);

  return (
    <Box>
      <SelectUserReceiveCertificate
        ownerHookForm={ownerHookForm}
        onUserChange={handleUserChange}
      />
    </Box>
  );
};

export default OwnerInfoArtistCreateCer;
